import { render } from "./TransactionsModal_two.vue?vue&type=template&id=6ea5d0c7&scoped=true"
import script from "./TransactionsModal_two.vue?vue&type=script&lang=js"
export * from "./TransactionsModal_two.vue?vue&type=script&lang=js"

import "./TransactionsModal_two.vue?vue&type=style&index=0&id=6ea5d0c7&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea5d0c7"]])

export default __exports__